import { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";

const KEY = "nvsn-theme";

export function useThemeClass() {
  const [theme, setTheme] = useState(() => localStorage.getItem(KEY) || "dark");
  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle("theme-light", theme === "light");
    localStorage.setItem(KEY, theme);
    return () => root.classList.remove("theme-light");
  }, [theme]);
  return [theme, setTheme];
}

export const ThemeToggle = ({ theme, setTheme, testid = "theme-toggle" }) => {
  const opt = (id, Icon, label) => (
    <button type="button" data-testid={`${testid}-${id}`} onClick={() => setTheme(id)} aria-pressed={theme === id}
      className={`flex-1 flex items-center justify-center gap-1.5 py-1.5 rounded-full text-[11px] transition-colors ${theme === id ? "bg-[#4deb7a] text-[#080808] font-medium" : "text-[#8f8f8f] hover:text-[#e8e8e8]"}`}>
      <Icon className="h-3.5 w-3.5" strokeWidth={1.5} /> {label}
    </button>
  );
  return (
    <div data-testid={testid} className="flex items-center gap-1 p-1 border border-[#222] rounded-full bg-[#0e0e0e]">
      {opt("dark", Moon, "Dark")}
      {opt("light", Sun, "Light")}
    </div>
  );
};
